/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Input } from 'antd'
import React from 'react'
import { Theme } from '@themes/theme'

const MessageLinkInputStyle = (theme: Theme) => css`
  &.ant-input {
    width: calc(100% - 28px);
    height: auto;
    margin: 30px 14px 10px;
    padding: 0;
    font-size: ${theme.font.medium};
    font-weight: ${theme.fontW.medium};
    background: none;
    border-radius: 0;
    border-right: 0;
    border-left: 0;
    border-top: 0;
    border-bottom: 1px solid ${theme.color.modalDarkBg};
    resize: none;

    &::placeholder {
      color: #acacac !important;
    }

    &:hover,
    &:focus,
    &:active {
      border-bottom: 1px solid ${theme.color.modalDarkBg} !important;
    }
  }
`

interface MessageLinkInputProps {
  value?: string
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
}

const MessageLinkInput: React.FC<MessageLinkInputProps> = ({ value, onChange }) => {
  return (
    <Input.TextArea
      name="messageLinkInput"
      id="messageLinkInput"
      maxLength={600}
      autoSize={{ minRows: 1, maxRows: 6 }}
      placeholder="URL을 입력해주세요."
      css={MessageLinkInputStyle}
      onChange={onChange}
      defaultValue={value}
    />
  )
}

export default MessageLinkInput
